import { actions as collection } from '@/plugins/Collection'

export default collection.toEnumOptions([
  'Co-funding Loan',
  'Portfolio',
  'Private Equity'
])
